import { motion } from 'framer-motion'
import { Award, Building2, Clock, Tag } from 'lucide-react'

const benefits = [
  {
    icon: Award,
    title: 'Profissional experiente',
    description: 'Anos de experiência entregando soluções com qualidade e segurança.',
  },
  {
    icon: Building2,
    title: 'Atendimento residencial e comercial',
    description: 'Atendemos casas, apartamentos, escritórios e comércios.',
  },
  {
    icon: Clock,
    title: 'Capricho e pontualidade',
    description: 'Respeitamos seu tempo e cuidamos de cada detalhe do serviço.',
  },
  {
    icon: Tag,
    title: 'Preço justo e transparente',
    description: 'Orçamentos claros, sem surpresas e com ótimo custo-benefício.',
  },
]

const WhyChooseSection = () => {
  return (
    <section
      id="sobre"
      data-testid="why-choose-section"
      className="py-24 md:py-32 bg-[#062B63] relative overflow-hidden"
    >
      {/* Dot grid texture */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage: 'radial-gradient(rgba(242,179,0,0.15) 1px, transparent 1px)',
          backgroundSize: '32px 32px',
        }}
      />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-24 items-start">
          {/* Left: Heading */}
          <div>
            <motion.p
              className="text-[#F2B300] text-[11px] font-bold uppercase tracking-[0.2em] mb-5"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
            >
              Diferenciais
            </motion.p>
            <motion.h2
              className="text-4xl sm:text-5xl lg:text-[3.5rem] xl:text-[4rem] font-bold text-white font-outfit tracking-tight leading-[0.95] mb-6"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.1, duration: 0.7 }}
            >
              Por que nos
              <br />
              <span className="text-[#F2B300]">escolher?</span>
            </motion.h2>
            <motion.p
              className="text-white/55 text-base lg:text-lg leading-relaxed max-w-sm"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.25 }}
            >
              Somos a escolha certa para quem busca praticidade, confiança e qualidade em Balneário Camboriú e região.
            </motion.p>

            {/* Decorative line */}
            <motion.div
              className="mt-10 w-16 h-px bg-[#F2B300]"
              initial={{ scaleX: 0 }}
              whileInView={{ scaleX: 1 }}
              viewport={{ once: true }}
              style={{ transformOrigin: 'left' }}
              transition={{ delay: 0.4, duration: 0.6 }}
            />
          </div>

          {/* Right: Benefits list */}
          <div className="space-y-7">
            {benefits.map((b, i) => {
              const Icon = b.icon
              return (
                <motion.div
                  key={b.title}
                  data-testid={`benefit-${i + 1}`}
                  className="flex gap-5 group"
                  initial={{ opacity: 0, x: 30 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.1, duration: 0.55 }}
                >
                  <div className="flex-shrink-0 w-11 h-11 bg-[#F2B300]/15 border border-[#F2B300]/25 flex items-center justify-center group-hover:bg-[#F2B300]/25 transition-colors duration-300">
                    <Icon size={19} className="text-[#F2B300]" />
                  </div>
                  <div>
                    <h4 className="text-white font-bold text-[0.95rem] mb-1.5 font-outfit">
                      {b.title}
                    </h4>
                    <p className="text-white/50 text-sm leading-relaxed">{b.description}</p>
                  </div>
                </motion.div>
              )
            })}
          </div>
        </div>
      </div>
    </section>
  )
}

export default WhyChooseSection
